import React from 'react'
import { CloseCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import NotificationItem from '../NotificationItem'
import Spacer from '../../../../atoms/Spacer'
import ViewMore from '../ViewMore'

import useStyles from './styles'

const ACTION_HEIGHT = '65.5px'

const MobileMenu = ({
  options,
  onSelect,
  LIMIT,
  fullHeigth,
  children,
  extraTopChildren
}) => {
  const theme = useTheme()

  const [open, setOpen] = React.useState(false)
  const height = fullHeigth
    ? '100%'
    : `${window.innerHeight}px - ${ACTION_HEIGHT}`
  const classes = useStyles({ height })

  return (
    <>
      <div className={classes.root}>
        <div onClick={() => setOpen(true)} className={classes.children}>
          {children}
        </div>
      </div>

      {open && (
        <div className={classes.menu}>
          {extraTopChildren ? (
            extraTopChildren(() => setOpen(false))
          ) : (
            <div className={classes.title}>
              <div>Notifications</div>

              <CloseCircle
                size={theme.size.base}
                onClick={() => setOpen(false)}
                className={classes.close}
              />
            </div>
          )}

          <div className={classes.items}>
            {options.slice(0, LIMIT).map(opt => {
              const key = opt?.key ?? opt
              return (
                <NotificationItem
                  key={key}
                  id={key}
                  options={options}
                  LIMIT={LIMIT}
                  onMobile
                  onSelect={onSelect}
                />
              )
            })}

            <Spacer />
          </div>

          <div className={classes.moreBlock}>
            <ViewMore
              optionsLength={options.length}
              LIMIT={LIMIT}
              className={classes.more}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default MobileMenu
